<form>
  <div class="row">
    <div class="card">
      <h5 class="card-header">{{'forms.featured' | translate}}</h5>
      <div class="card-body">
        <h5 class="card-title">{{'forms.specialTitle' | translate}}</h5>
        <p class="card-text">{{'forms.supportingText' | translate}}</p>
        <a href="#" class="btn btn-primary">{{'forms.goSomewhere' | translate}}</a>
      </div>
    </div>

    <div class="col-lg-12">
      <div class="card col-lg-12">
        <div class="card-body col-lg-12">
          <h4 class="card-title text-center text-uppercase">{{'registration.generalInformation' | translate}}</h4>
          <div class="form-group row">
            <label class="col-md-6 col-form-label">{{'fields.lastName' | translate}}</label>
            <div class="col-md-6">
              <input class="form-control" type="text">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <button type="submit" class="btn btn-primary">{{'common.submit' | translate}}</button>
</form>
